import React from 'react';
import { CheckCircle2, ClipboardList, FileText } from 'lucide-react';
import { PulsePanel, PulseEmpty } from './PulsePanel';
import { useFitPaged, PageDots } from './pulseUtils';

const BAR_COLORS = ['#8E3FD8', '#19B5C9', '#2F9BEA', '#F5B400', '#F27BA6', '#22B04B'];

export const PulseTasks = ({ t, rotateSeconds }) => {
  const { ref, slice, page, pages } = useFitPaged(t.by_staff, (rotateSeconds || 8) * 1000);
  return (
  <PulsePanel icon={ClipboardList} title="Tasks" pill="Today" testid="pulse-tasks" className="h-full">
    <div className="grid grid-cols-2 gap-3 px-4 pt-4">
      <div className="rounded-xl bg-[#ecf8ee] flex items-center gap-4 px-4 py-3" data-testid="pulse-tasks-assigned">
        <FileText size={50} color="#22B04B" fill="#22B04B" stroke="#fff" />
        <div><div className="text-[16px] font-bold whitespace-nowrap">Assigned Today</div><div className="text-[44px] font-extrabold leading-none" data-testid="pulse-tasks-assigned-value">{t.assigned_today}</div></div>
      </div>
      <div className="rounded-xl bg-[#e9f4fd] flex items-center gap-3 px-4 py-3" data-testid="pulse-tasks-completed">
        <CheckCircle2 size={48} color="#fff" fill="#2F9BEA" />
        <div><div className="text-[16px] font-bold whitespace-nowrap">Completed Today</div>
          <div className="flex items-end gap-2"><span className="text-[44px] font-extrabold leading-none" data-testid="pulse-tasks-completed-value">{t.completed_of_assigned}</span>
            <span className="leading-none pb-1"><span className="block text-[26px] font-extrabold text-[#19A3B8]" data-testid="pulse-tasks-completion-rate">{t.completion_rate}%</span><span className="text-[12px] font-semibold">completion rate</span></span></div></div>
      </div>
    </div>
    <div className="px-5 pt-4 flex-1 min-h-0 flex flex-col">
      <div className="text-[25px] font-bold mb-2">Task Status</div>
      {t.by_staff.length === 0 ? <PulseEmpty text="No tasks assigned for today" testid="pulse-tasks-empty" /> : <div key={page} ref={ref} className="flex-1 min-h-0 overflow-hidden pulse-fade-in">{slice.map((c, i) => (
        <div key={c.name} className="grid grid-cols-[200px_minmax(0,1fr)_70px] items-center py-2" data-testid="pulse-task-staff-row">
          <span className="text-[19px] font-medium truncate pr-2">{c.name}</span>
          <div className="h-[26px] bg-[#efeaf1] rounded overflow-hidden"><div className="h-full rounded pulse-bar-fill" style={{ width: `${c.percent}%`, background: BAR_COLORS[(page * 6 + i) % BAR_COLORS.length] }} /></div>
          <span className="text-right text-[19px] font-bold tabular-nums">{c.completed}/{c.assigned}</span>
        </div>
      ))}</div>}
      <PageDots page={page} pages={pages} testid="pulse-task-staff-pages" />
    </div>
  </PulsePanel>
  );
};
